import { Icon as CroplerIcon } from '@cropler/ui-kit';
import type { ReactNode } from 'react';
import type { TFunction } from 'i18next';

type NotesType = {
  id: string;
  title: string;
  icon: ReactNode;
};

type NotesTypes = {
  harvesting: NotesType;
  planting: NotesType;
  text: NotesType;
  other: NotesType;
};

// Notes types
export const getNoteTypes = (t: TFunction): NotesTypes => ({
  harvesting: {
    id: 'harvesting',
    title: t('notes.types.harvesting'),
    icon: <CroplerIcon name="harvesting" width={16} height={16} />,
  },
  planting: {
    id: 'planting',
    title: t('notes.types.planting'),
    icon: <CroplerIcon name="planting" width={16} height={16} />,
  },
  text: {
    id: 'text',
    title: t('notes.types.text'),
    icon: <CroplerIcon name="note" width={16} height={16} />,
  },
  other: {
    id: 'other',
    title: t('notes.types.other'),
    icon: <CroplerIcon name="tractor" width={16} height={16} />,
  },
});

// The array of notes types
export const getListNotesTypes = (t: TFunction): NotesType[] => {
  const NoteTypes = getNoteTypes(t);
  return Object.entries(NoteTypes).map(([key, value]) => ({
    id: key,
    title: value.title,
    icon: value.icon,
  }));
};